import {
    PAYMENT_METHODS_CREATE_SESSION_ERROR,
    PAYMENT_METHODS_CREATE_SESSION_START,
    PAYMENT_METHODS_CREATE_SESSION_SUCCESS,
    PAYMENT_METHODS_FETCH_ERROR,
    PAYMENT_METHODS_FETCH_START,
    PAYMENT_METHODS_FETCH_SUCCESS,
    PAYMENT_METHODS_RESET,
    PAYMENT_METHODS_SURCHARGE_QUOTE_CLEAR,
    PAYMENT_METHODS_SURCHARGE_QUOTE_ERROR,
    PAYMENT_METHODS_SURCHARGE_QUOTE_START,
    PAYMENT_METHODS_SURCHARGE_QUOTE_SUCCESS,
    PAYMENT_METHODS_TOKEN_PAYMENT_ERROR,
    PAYMENT_METHODS_TOKEN_PAYMENT_RESET,
    PAYMENT_METHODS_TOKEN_PAYMENT_START,
    PAYMENT_METHODS_TOKEN_PAYMENT_SUCCESS,
    PaymentMethodsAction
} from 'actions/paymentMethods/PaymentMethodsActionsTypes';
import {
    PaymentMethodsState,
    TokenPaymentStatus
} from 'reducers/paymentMethods/PaymentMethodsState';
import { Reducer } from 'redux';

const initialState: PaymentMethodsState = {
    loading: false,
    paymentMethods: [],
    paymentMethodsFetched: false,

    adyenSession: null,
    sessionLoading: false,

    surchargeQuote: null,
    surchargeLoading: false,

    tokenPaymentStatus: TokenPaymentStatus.Idle
};

export const paymentMethodsReducer: Reducer<PaymentMethodsState, PaymentMethodsAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case PAYMENT_METHODS_RESET:
            return initialState;

        case PAYMENT_METHODS_FETCH_START:
            return { ...state, loading: true };
        case PAYMENT_METHODS_FETCH_SUCCESS:
            return {
                ...state,
                loading: false,
                paymentMethods: action.payload.paymentMethods,
                paymentMethodsFetched: true
            };
        case PAYMENT_METHODS_FETCH_ERROR:
            return {
                ...state,
                loading: false,
                paymentMethodsFetched: true
            };

        case PAYMENT_METHODS_CREATE_SESSION_START:
            return { ...state, sessionLoading: true, adyenSession: null };
        case PAYMENT_METHODS_CREATE_SESSION_SUCCESS:
            return {
                ...state,
                sessionLoading: false,
                adyenSession: action.payload.session
            };
        case PAYMENT_METHODS_CREATE_SESSION_ERROR:
            return { ...state, sessionLoading: false, adyenSession: null };

        case PAYMENT_METHODS_SURCHARGE_QUOTE_START:
            return { ...state, surchargeLoading: true };
        case PAYMENT_METHODS_SURCHARGE_QUOTE_SUCCESS:
            return {
                ...state,
                surchargeLoading: false,
                surchargeQuote: action.payload.quote
            };
        case PAYMENT_METHODS_SURCHARGE_QUOTE_ERROR:
            return {
                ...state,
                surchargeLoading: false,
                surchargeQuote: null
            };
        case PAYMENT_METHODS_SURCHARGE_QUOTE_CLEAR:
            return { ...state, surchargeQuote: null, surchargeLoading: false };

        case PAYMENT_METHODS_TOKEN_PAYMENT_START:
            return { ...state, tokenPaymentStatus: TokenPaymentStatus.Processing };
        case PAYMENT_METHODS_TOKEN_PAYMENT_SUCCESS:
            return { ...state, tokenPaymentStatus: TokenPaymentStatus.Success };
        case PAYMENT_METHODS_TOKEN_PAYMENT_ERROR:
            return { ...state, tokenPaymentStatus: TokenPaymentStatus.Error };
        case PAYMENT_METHODS_TOKEN_PAYMENT_RESET:
            return { ...state, tokenPaymentStatus: TokenPaymentStatus.Idle };

        default:
            return state;
    }
};
